import { useEffect, useRef } from 'react';
import { frameTimecode } from '../../domain/frame-timecode';

export type MobilePanel = 'film' | 'controls' | 'timeline';

export function MobilePanelHeading({ title, onClose }: { title: string; onClose: () => void }) {
  const close = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    const previous = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    close.current?.focus({ preventScroll: true });
    const keydown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && !event.defaultPrevented) { event.preventDefault(); onClose(); }
    };
    document.addEventListener('keydown', keydown);
    return () => { document.removeEventListener('keydown', keydown); previous?.focus({ preventScroll: true }); };
  }, [onClose, title]);
  return <div className="mobile-panel-heading"><h2>{title}</h2><button ref={close} type="button" onClick={onClose}>Done</button></div>;
}

export function MobilePlayback({ progress, duration, playing, invalid, onPlay, onSeek, onSeekEnd, onTimeline, timelineOpen }: {
  progress: number; duration: number; playing: boolean; invalid: boolean; timelineOpen: boolean;
  onPlay: () => void; onSeek: (progress: number) => void; onSeekEnd: () => void; onTimeline: () => void;
}) {
  const last = Math.max(1, Math.round(duration * 30) - 1);
  const frame = Math.round(progress * last);
  return <div className="mobile-film-controls" aria-label="Film playback" inert={timelineOpen} aria-hidden={timelineOpen || undefined}>
    <button type="button" className="primary" aria-pressed={playing} disabled={!playing && invalid} onClick={onPlay}>{playing ? 'Pause' : 'Play'}</button>
    <input type="range" aria-label="Film scrubber" min={0} max={last} step={1} value={frame}
      aria-valuetext={frameTimecode(frame)} onChange={event => onSeek(Number(event.target.value) / last)}
      onPointerUp={onSeekEnd} onPointerCancel={onSeekEnd} onKeyUp={onSeekEnd} onBlur={onSeekEnd} />
    <output>{frameTimecode(frame)}</output>
    <button type="button" aria-controls="composing-timeline" aria-expanded={timelineOpen} onClick={onTimeline}>Timeline</button>
  </div>;
}
